/* ==== AVR Newsletter Modal — v3 ==== */

(function () {
    'use strict';

    const modal = document.getElementById('subscribe-modal');
    if (!modal) return; // snippet disabled or not rendered

    // --- Config from data attributes (set by Liquid / footer schema) ---
    const DELAY_MS    = parseInt(modal.dataset.delay      || '30', 10) * 1000;
    const SCROLL_PCT  = parseInt(modal.dataset.scroll     || '55', 10);
    const RESHOW_DAYS = parseInt(modal.dataset.reshowDays || '7',  10);

    // --- State detection from DOM (no inline scripts, no variable collision) ---
    const hasSuccess  = !!modal.querySelector('.modal-success');
    const hasError    = !!modal.querySelector('.modal-error');
    const reshowModal = hasSuccess || hasError;

    // Mark signed up in localStorage immediately if form succeeded
    if (hasSuccess) localStorage.setItem('signedUp', 'true');

    const signedUpInStorage = localStorage.getItem('signedUp') === 'true';

    let modalTriggered = false;

    // --- Gate logic ---
    function canShowModal() {
        if (reshowModal) return true;           // success/error always shows — checked before signedUp
        if (signedUpInStorage) return false;    // already subscribed
        if (window.innerHeight <= 400) return false; // tiny/embedded viewports

        const lastShown = localStorage.getItem('modalLastShown');
        if (!lastShown) return true;            // never shown before

        const daysSince = (Date.now() - parseInt(lastShown, 10)) / (1000 * 86400);
        return daysSince >= RESHOW_DAYS;
    }

    // --- Open modal ---
    function showModal() {
        if (!canShowModal()) return;

        // Append current URL to the hidden referrer input
        const referInput = modal.querySelector('#modal-refer');
        if (referInput) referInput.value += window.location.href;

        // Set initial animation state, then make visible
        modal.style.opacity = '0';
        modal.style.transform = 'translateY(18px)';
        modal.style.display = 'flex';
        modal.showModal();

        // Double rAF: browser must paint the initial state before transition fires
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                modal.style.opacity = '1';
                modal.style.transform = 'translateY(0)';
            });
        });

        // Only record timestamp for organic (non-reshow) displays
        if (!reshowModal) localStorage.setItem('modalLastShown', Date.now().toString());

        // Close button — once: true prevents duplicate listeners on reopen
        const closeBtn = modal.querySelector('#modal-close-icon');
        if (closeBtn) closeBtn.addEventListener('click', closeModal, { once: true });

        // Dismiss text link (loss-framed copy, inside form as type="button")
        const dismissBtn = modal.querySelector('.modal-dismiss-text');
        if (dismissBtn) dismissBtn.addEventListener('click', closeModal, { once: true });

        // Backdrop click — the <dialog> element IS the backdrop target
        modal.addEventListener('click', function onBackdrop(e) {
            if (e.target === modal) {
                modal.removeEventListener('click', onBackdrop);
                closeModal();
            }
        });

        // Escape key fires 'cancel' on <dialog>, bypassing closeModal() animation.
        // once: true auto-removes listener; e.preventDefault() stops native instant close.
        modal.addEventListener('cancel', function (e) {
            e.preventDefault();
            closeModal();
        }, { once: true });
    }

    // --- Close modal ---
    function closeModal() {
        if (!modal.open) return; // guard against double-close (e.g. rapid backdrop clicks)
        modal.style.opacity = '0';
        modal.style.transform = 'translateY(10px)';
        setTimeout(() => {
            modal.close();
            modal.style.display = 'none';
        }, 380);
    }

    // --- Trigger (once only) ---
    function tryTriggerModal() {
        if (modalTriggered) return;
        modalTriggered = true;
        showModal();
    }

    // --- Scroll depth helper ---
    function getScrollPct() {
        const h = document.documentElement;
        const scrollTop    = h.scrollTop;
        const scrollHeight = h.scrollHeight - h.clientHeight;
        return scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
    }

    // --- Initialise ---
    window.addEventListener('load', function () {

        // Success/error: show immediately, skip scroll/time triggers
        if (reshowModal) {
            showModal();
            return;
        }

        // Trigger 1: scroll 40% (or configured %) — shows intent
        function onScroll() {
            if (getScrollPct() >= SCROLL_PCT) {
                window.removeEventListener('scroll', onScroll);
                tryTriggerModal();
            }
        }
        window.addEventListener('scroll', onScroll, { passive: true });

        // Trigger 2: time fallback — catches users who don't scroll
        setTimeout(tryTriggerModal, DELAY_MS);
    });

}());
